<div class="grid template-cols-36 p-24">
  <div class="d-flex flex gap-8 g-col-30">
 <kendo-grid
    [data]="gridData$"
    scrollable="none"
    [pageable]="true"
    [pageSize]="itemsPerPage()"
    [skip]="gridState.skip"
    [sortable]="true"
    [sort]="gridState.sort"
    [filterable]="true"
    (pageChange)="onPageChange($event, itemsPerPage(), params, reload$)"
    [filter]="gridState.filter"
    [loading]="isLoadingGridData$.value"
    (dataStateChange)="onDataStateChange($event)"
    (cellClick)="onGridRowClick($event)">
    <kendo-grid-column field="id" [filterClass]="'filter-button'" [headerClass]="'filter-button'" [width]="64">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
        <button kendoTooltip type="button" [showOn]="'hover'" title="{{ 'REMOVE_FILTERS' | translate | capitalize }}">
          <i tabindex="0" (keydown.enter)="clearCustomFilters(itemsPerPage(), params, reload$)" class="rc-icon-clear-filter" (click)="clearCustomFilters(itemsPerPage(), params, reload$)"></i>
        </button>
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-checkbox  [checkedState]="dataItem.id === selectedOrder()?.id" (checkedStateChange)="removeOrSetSelection($event, dataItem)"></kendo-checkbox>
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="documentNumber" title="{{ 'DOCUMENT_NUMBER' | translate }}" [sortable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-textbox (valueChange)="setCustomFilter($event, 'documentNumber', params, reload$)" [value]="getParamValue('documentNumber', params)"></kendo-textbox>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.documentNumber }}
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="reference" title="{{ 'REFERENCE' | translate }}" [sortable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-textbox (valueChange)="setCustomFilter($event, 'reference', params, reload$)" [value]="getParamValue('reference', params)"></kendo-textbox>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.reference }}
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="clientName" title="{{ 'CLIENT' | translate }}" [sortable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-textbox (valueChange)="setCustomFilter($event, 'clientName', params, reload$)" [value]="getParamValue('clientName', params)"></kendo-textbox>
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.clientName }}
        </ng-template>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="desiredDeliveryWeek" title="{{ 'DELIVERY_WEEK' | translate }}" [sortable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-textbox (valueChange)="setCustomFilter($event, 'desiredDeliveryWeek', params, reload$)" [value]="getParamValue('desiredDeliveryWeek', params)"></kendo-textbox>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
      @if(!this.isLoadingGridData$.value) {
        <div class="empty-grid-template">
          <div class="grid-logo">
            <i class="rc-icon-store fc-primary-500"></i>
          </div>
          <div class="grid-message">
            {{ "EMPTY_GRID_RESULT" | translate: { entity: "CLIENT_ORDERS" | translate } | capitalize }}
          </div>
        </div>
      }
    </ng-template>

    <ng-template kendoGridLoadingTemplate>
      <rc-list-skeleton [userSettings]="userSettings()!" [colAmount]="4" [state]="gridState" [itemsPerPage]="itemsPerPage()" [forceCustomItemsPerPage]="true"></rc-list-skeleton>
    </ng-template>
  </kendo-grid>
  </div>
  <div class="d-flex flex-column gap-24 g-col-6 border-left-1 border-left-color-neutral-300 ps-24" [style.min-width.px]="316">
      <div class="d-flex flex-column g-col-6">
        <kendo-formfield showHints="initial" showErrors="initial">
          <kendo-label
            labelCssClass="k-form-label"
            [for]="reference"
            [text]="'REFERENCE' | translate | uppercase"></kendo-label>
          <kendo-textbox
            #reference
            [value]="getParamValue('reference', params)"
            (valueChange)="setCustomFilter($event, 'reference', params, reload$)"
            />
        </kendo-formfield>
      </div>
    <div class="d-flex flex-column g-col-6">
        <kendo-formfield showHints="initial" showErrors="initial">
          <kendo-label
            labelCssClass="k-form-label"
            [for]="da"
            [text]="'DELIVERY_ADDRESS' | translate | uppercase"></kendo-label>
          <kendo-textbox
            #da
            [value]="getParamValue('deliveryAddressSearch', params)"
            (valueChange)="setCustomFilter($event, 'deliveryAddressSearch', params, reload$)"
          />
        </kendo-formfield>
      </div>
      <div class="d-flex flex-column g-col-6">
        <kendo-formfield showHints="initial" showErrors="initial">
          <kendo-label
            labelCssClass="k-form-label"
            [for]="deliveryDate"
            [text]="'DELIVERY_DATE' | translate | uppercase"></kendo-label>
          <rc-date-range-filter
            #deliveryDate
            [field]="'desiredDeliveryDate'"
            (valueChange)="setCustomBetweenFilter(deliveryDate.value(), 'desiredDeliveryDate', params, reload$)"
            [fieldTranslationKey]="'DELIVERY_DATE'" />
        </kendo-formfield>
      </div>
  </div>
</div>
